import React from 'react';
import '../dana.css';
import 'antd/dist/antd.css';
import { Switch } from 'antd';

const onChange = (checked) => {
    console.log(`switch to ${checked}`);
}
function Buku() {
    return (
        <div className="card-dana-flow">
            <div className="card-dana1">
                <h5 className="card-dana-title">Pilih Jenis Buku</h5>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Buku Pelajaran Sekolah" />
                    <h6 className="radio-btn-value">Buku Pelajaran Sekolah</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Buku Novel" />
                    <h6 className="radio-btn-value">Buku Novel</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Majalah" />
                    <h6 className="radio-btn-value">Majalah</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Buku Pengetahuan" />
                    <h6 className="radio-btn-value">Buku Pengetahuan(selain buku sekolah)</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Masukan Jenis Buku" />
                    <input className="radio-btn-value-1" type="text" placeholder="Masukan Jenis Buku" />
                </div>
            </div>
            <div className="card-dana2">
                <h5 className="card-dana-title">Catatan</h5>
                <textarea className="textarea-donasi" type="text" placeholder="Masukan Catatan">

                </textarea>
            </div>
            <div className="toggle-row">
                <h6 className="card-dana-title1">Tampilkan Sebagai Anonim</h6>
                <div className="switch-toggle">
                    <Switch defaultChecked onChange={onChange} />
                </div>
            </div>
            <button className="donasi-sekarang-btn-2">Donasi Sekarang</button>
        </div>
    )
}

export default Buku;